export default function getEditActionButtonStyle(isHighlighted) {
  return {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "26px",
    height: "26px",
    borderRadius: "8px",
    border: "1px solid #0f766e",
    background: isHighlighted ? "#14b8a6" : "#0f766e",
    color: "#ffffff",
    cursor: "pointer",
    boxShadow: isHighlighted ? "0 8px 18px rgba(20, 184, 166, 0.24)" : "0 4px 12px rgba(15, 23, 42, 0.08)",
    transition: "background-color 0.18s ease, color 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease"
  };
}